module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['Utils']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module Utils URL not available') },
        init: (arg) => { throw new Error('Module Utils URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['Utils'].get(request),
      init: (arg) => {
        try {
          return window['Utils'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: Utils')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module Utils not available') },
      init: (arg) => { throw new Error('Module Utils not available') }
    })
    document.head.appendChild(script);
  });